import { ADD_MEMBER, UPDATE_MEMBER_REQUEST, UPDATE_MEMBER, DELETE_MEMBER, SEARCH_MEMBER_TABLE, GO_TO_PAGE_MEMBER_TABLE, SET_PAGE_SIZE_MEMBER_TABLE, SORT_MEMBER_TABLE, IUpdateableMemberData, ADD_WORKFLOW_TO_MEMBER, UPDATE_MEMBER_CUSTOM_FIELD_DATA, ADD_GROUP_TO_MEMBER, REMOVE_GROUP_FROM_MEMBER, FilterMemberTableAction, FILTER_MEMBER_TABLE, AddMemberAction, UpdateMemberRequestAction, UpdateMemberAction, AddGroupToMemberAction, RemoveGroupFromMemberAction, AddWorkflowToMemberAction, UpdateMemberCustomFieldDataAction, DeleteMemberAction, SearchMemberTableAction, GoToPageMemberTableAction, SetPageSizeMemberTableAction, SortMemberTableAction, UnArchiveMemberAction, UN_ARCHIVE_MEMBER, RemoveWorkflowFromMemberAction, REMOVE_WORKFLOW_FROM_MEMBER, BulkAddMembersAction, BulkUpdateMembersAction, BulkUpdateMembersRequestAction, BULK_UPDATE_MEMBERS_REQUEST, BULK_ADD_MEMBERS, BULK_UPDATE_MEMBERS, BulkAddGroupsToMembersAction, BULK_ADD_GROUPS_TO_MEMBERS, MemberGroupLink, BulkRemoveGroupsFromMembersAction, BULK_REMOVE_GROUPS_FROM_MEMBERS, SetIsFilteringForMemberTableAction, SET_IS_FILTERING_FOR_MEMBER_TABLE, SetIsShowingAddFormForMembersAction, SetIsShowingCSVFormForMembersAction, SetIsShowingFilterFormForMembersAction, SetIsShowingModifyFormForMembersAction, SET_IS_SHOWING_ADD_FORM_FOR_MEMBERS, SET_IS_SHOWING_CSV_FORM_FOR_MEMBERS, SET_IS_SHOWING_FILTER_FORM_FOR_MEMBERS, SET_IS_SHOWING_MODIFY_FORM_FOR_MEMBERS, IMember, AppendMembersData, APPEND_MEMBERS_DATA, UpdateMembersLocationAction, UPDATE_MEMBERS_LOCATION, UpdateMembersLocationRequestAction, UPDATE_MEMBERS_LOCATION_REQUEST, RECALCULATE_COMPUTED_FIELDS_FOR_MEMBER, RecalculateComputedFieldsForMemberAction, ChangeDeltaForMemberComputedFields, BULK_RECALCULATE_COMPUTED_FIELDS_FOR_MEMBER, BulkUpdateMemberComputedFieldDataAction, UpdateMemberComputedFieldDataAction, UPDATE_MEMBER_COMPUTED_FIELD_DATA, BULK_UPDATE_MEMBER_COMPUTED_FIELD_DATA, RecomputeAllMembersAction, RECOMPUTE_ALL_MEMBERS, ComputedFieldUpdatePayloadForMember, CLEAR_MEMBER_ENTRIES, SET_TOTAL_NUMBER_OF_MEMBERS_FROM_SERVER, ISetTotalNumberOfMembersFromServerAction } from './types';
import moment from 'moment';
import { SearchIndex } from '../../helpers/common-types';
import { CustomFieldDataHolder } from '../custom-fields/types';

export function addMember(payload: IUpdateableMemberData): AddMemberAction {
    const now = moment.utc().format();

    return {
        type: ADD_MEMBER,
        payload: {
            ...payload,
            createdTime: now,
            lastUpdatedTime: now,
            lastKnownLocation: undefined,
            lastMetTime: undefined,
            lastUpdatedCustomFieldTime: now,
            lastUpdateTimeForFields: {},
            workflows: {},
        },
        currentTime: now,
    }
}

export function updateMemberRequest(payload: IUpdateableMemberData): UpdateMemberRequestAction {
    return {
        type: UPDATE_MEMBER_REQUEST,
        payload,
    }
}

export function updateMember(payload: IUpdateableMemberData): UpdateMemberAction {
    return {
        type: UPDATE_MEMBER,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function addGroupToMember(groupId: string, groupTypeId: string, memberId: string): AddGroupToMemberAction {
    return {
        type: ADD_GROUP_TO_MEMBER,
        groupId,
        groupTypeId,
        memberId,
    }
}

export function removeGroupFromMember(groupId: string, groupTypeId: string, memberId: string): RemoveGroupFromMemberAction {
    return {
        type: REMOVE_GROUP_FROM_MEMBER,
        groupId,
        groupTypeId,
        memberId,
    }
}

export function addWorkflowToMember(memberId: string, workflowTypeId: string, workflowId: string): AddWorkflowToMemberAction {
    return {
        type: ADD_WORKFLOW_TO_MEMBER,
        memberId,
        workflowTypeId,
        workflowId,
    }
}

export function removeWorkflowFromMember(memberId: string, workflowTypeId: string, workflowId: string): RemoveWorkflowFromMemberAction {
    return {
        type: REMOVE_WORKFLOW_FROM_MEMBER,
        memberId,
        workflowTypeId,
        workflowId,
    }
}

export function updateMemberCustomFieldData(workflowId: string, memberId: string, customFieldData: CustomFieldDataHolder): UpdateMemberCustomFieldDataAction {
    return {
        type: UPDATE_MEMBER_CUSTOM_FIELD_DATA,
        workflowId,
        memberId,
        customFieldData,
        currentTime: moment.utc().format(),
    }
}

export function updateMemberComputedFieldData(memberId: string, customFieldData: CustomFieldDataHolder): UpdateMemberComputedFieldDataAction {
    return {
        type: UPDATE_MEMBER_COMPUTED_FIELD_DATA,
        memberId,
        customFieldData,
        currentTime: moment.utc().format(),
    }
}

export function bulkUpdateMemberComputedFieldData(payload: Array<ComputedFieldUpdatePayloadForMember>): BulkUpdateMemberComputedFieldDataAction {
    return {
        type: BULK_UPDATE_MEMBER_COMPUTED_FIELD_DATA,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function recomputeAllMembers(): RecomputeAllMembersAction {
    return {
        type: RECOMPUTE_ALL_MEMBERS,
    };
}

export function updateMembersLocationRequest(memberIds: Array<string>, locationId: string): UpdateMembersLocationRequestAction {
    return {
        type: UPDATE_MEMBERS_LOCATION_REQUEST,
        memberIds,
        locationId,
        currentTime: moment.utc().format(),
    }
}

export function updateMembersLocation(memberIds: Array<string>, locationId: string): UpdateMembersLocationAction {
    return {
        type: UPDATE_MEMBERS_LOCATION,
        memberIds,
        locationId,
        currentTime: moment.utc().format(),
    }
}

export function deleteMember(id: string): DeleteMemberAction {
    return {
        type: DELETE_MEMBER,
        id,
        currentTime: moment.utc().format(),
    }
}

export function unArchiveMember(id: string): UnArchiveMemberAction {
    return {
        type: UN_ARCHIVE_MEMBER,
        id,
        currentTime: moment.utc().format(),
    }
}

export function searchMemberTable(searchTerm: string): SearchMemberTableAction {
    return {
        type: SEARCH_MEMBER_TABLE,
        searchTerm,
    }
}

export function filterMemberTable(projects: Array<string>, types: Array<string>, locations: Array<string>, customFields: { [customFieldId: string]: Array<string> }, createdDateRange: Array<string>, lastUpdatedDateRange: Array<string>, unsynced: boolean, archived: boolean): FilterMemberTableAction {
    return {
        type: FILTER_MEMBER_TABLE,
        projects,
        types,
        locations,
        customFields,
        createdDateRange,
        lastUpdatedDateRange,
        archived,
        unsynced,
    }
}

export function setIsFilteringForMemberTable(isFiltering: boolean): SetIsFilteringForMemberTableAction {
    return {
        type: SET_IS_FILTERING_FOR_MEMBER_TABLE,
        isFiltering,
    };
}

export function setTotalNumberOfMembers(totalNumberOfMembers: number): ISetTotalNumberOfMembersFromServerAction {
    return {
        type: SET_TOTAL_NUMBER_OF_MEMBERS_FROM_SERVER,
        totalNumberOfMembers,
    }
}

export function goToPageMemberTable(pageNumber: number): GoToPageMemberTableAction {
    return {
        type: GO_TO_PAGE_MEMBER_TABLE,
        pageNumber,
    }
}

export function setPageSizeMemberTable(pageSize: number): SetPageSizeMemberTableAction {
    return {
        type: SET_PAGE_SIZE_MEMBER_TABLE,
        pageSize,
    }
}

export function sortMemberTable(column: string, order: 'ASC' | 'DESC'): SortMemberTableAction {
    return {
        type: SORT_MEMBER_TABLE,
        column,
        order,
    }
}

export function bulkAddMember(payload: Array<IUpdateableMemberData>): BulkAddMembersAction {
    const now = moment.utc().format();

    const bulkAddPayload = payload.map(payload => {
        return {
            ...payload,
            createdTime: now,
            lastUpdatedTime: now,
            lastKnownLocation: undefined,
            lastMetTime: undefined,
            lastUpdatedCustomFieldTime: now,
            lastUpdateTimeForFields: {},
            workflows: {},
        };
    });

    return {
        type: BULK_ADD_MEMBERS,
        payload: bulkAddPayload,
        currentTime: now,
    }
}

export function bulkUpdateMembersRequest(payload: Array<IUpdateableMemberData>): BulkUpdateMembersRequestAction {
    return {
        type: BULK_UPDATE_MEMBERS_REQUEST,
        payload,
    }
}

export function bulkUpdateMembers(payload: Array<IUpdateableMemberData>): BulkUpdateMembersAction {
    return {
        type: BULK_UPDATE_MEMBERS,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function bulkAddGroupsToMembers(links: Array<MemberGroupLink>): BulkAddGroupsToMembersAction {
    return {
        type: BULK_ADD_GROUPS_TO_MEMBERS,
        links,
    }
}

export function bulkRemoveGroupsFromMembers(links: Array<MemberGroupLink>): BulkRemoveGroupsFromMembersAction {
    return {
        type: BULK_REMOVE_GROUPS_FROM_MEMBERS,
        links,
    }
}

export function setIsShowingAddFormForMembers(showValue: boolean): SetIsShowingAddFormForMembersAction {
    return {
        type: SET_IS_SHOWING_ADD_FORM_FOR_MEMBERS,
        showValue,
    }
}

export function setIsShowingModifyFormForMembers(showValue: boolean): SetIsShowingModifyFormForMembersAction {
    return {
        type: SET_IS_SHOWING_MODIFY_FORM_FOR_MEMBERS,
        showValue,
    }
}

export function setIsShowingFilterFormForMembers(showValue: boolean): SetIsShowingFilterFormForMembersAction {
    return {
        type: SET_IS_SHOWING_FILTER_FORM_FOR_MEMBERS,
        showValue,
    }
}

export function setIsShowingCSVFormForMembers(showValue: boolean): SetIsShowingCSVFormForMembersAction {
    return {
        type: SET_IS_SHOWING_CSV_FORM_FOR_MEMBERS,
        showValue,
    }
}

export function appendMembers(members: Array<IMember>): AppendMembersData {
    return {
        type: APPEND_MEMBERS_DATA,
        data: members,
    }
}

export function recalculateComputedFieldsForMember(
    memberId: string,
    memberChanged: boolean,
    locationChanged: boolean,
    groupTypesChanged: Array<string>,
    workflowTypesChanged: Array<string>,
): RecalculateComputedFieldsForMemberAction {
    return {
        type: RECALCULATE_COMPUTED_FIELDS_FOR_MEMBER,
        memberId,
        memberChanged,
        locationChanged,
        groupTypesChanged,
        workflowTypesChanged,
    }
};

export function bulkRecalculateComputedFieldsForMember(payload: Array<ChangeDeltaForMemberComputedFields>) {
    return {
        type: BULK_RECALCULATE_COMPUTED_FIELDS_FOR_MEMBER,
        payload,
    }
}

export function clearMemberEntries() {
    return {
        type: CLEAR_MEMBER_ENTRIES,
    }
}